<template>
  <router-link tag="div" id="order-item" :to="to">
    <!--<span class="order-icon"></span>-->
    <div
      :class="{
        container: true,
        isPay: item.payStatus === 0 || item.payStatus === 1
      }"
    >
      <div class="item-header">
        <div class="item-number">
          <p v-if="type !== 'tracking'">
            订单号：{{ item.orderNumber }}
            <van-icon
              class="btn-copy"
              name="description"
              @click.stop="handleCopyClick(item.orderNumber)"
              size="0.4rem"
            />
          </p>
          <p>
            运单号：{{ item.trackingNumber }}
            <van-icon
              v-if="item.trackingNumber"
              class="btn-copy"
              name="description"
              @click.stop="handleCopyClick(item.trackingNumber)"
              size="0.4rem"
            />
          </p>
        </div>
        <div v-if="item.isCollage === 1">
          <img
            style="height: 35px;width: 35px;margin-right: 0.5rem;"
            src="@/assets/icon_pingbao.png"
            alt=""
          />
        </div>
        <van-button
          class="logistics-button"
          type="primary"
          size="small"
          @click.stop="clickLogistics"
          >物流跟踪</van-button
        >
      </div>
      <div class="order-company">
        <p class="order-time">下单时间：{{ item.createDate }}</p>
<!--        <p>{{ item.logisticsCompanyName }}</p>-->
      </div>
      <div class="order-detail">
        <div style="text-align: left">
          <p class="area">
            {{ item.consignorCityName || item.beginOrganName }}
          </p>
          <p>{{ item.consignorName }}</p>
        </div>
        <div class="order-status">
          <p>{{ item.statusName }}</p>
        </div>
        <div style="text-align: right">
          <p class="area">{{ item.consigneeCityName || item.endOrganName }}</p>
          <p>{{ item.consigneeName }}</p>
        </div>
      </div>
      <!-- <van-button class="pay-button" type="warning" size="small" @click.stop="wechatPay" v-show="item.payStatus===0">
        运费支付
      </van-button>
      <van-button class="pay-button" type="warning" size="small" v-show="item.payStatus===1" disabled>已付款</van-button> -->
    </div>
  </router-link>
</template>

<script>
import { Toast } from "vant";

export default {
  name: "OrderItem",
  data() {
    return {};
  },
  props: {
    item: {
      type: Object,
      require: true
    },
    to: {
      type: String,
      require: true
    },
    type: {
      type: String
    }
  },
  methods: {
    clickLogistics() {
      if (this.item.orderNumber) {
        this.$router.push("/search/logistics/" + this.item.orderNumber);
      } else {
        this.$router.push("/search/logistics/" + this.item.trackingNumber);
      }
    },
    wechatPay() {
      let params = {
        params: {
          trackingId: this.item.trackingId || this.item.id
        }
      };
      this.$axios.post("pay/wechat", params).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data;
          WeixinJSBridge.invoke("getBrandWCPayRequest", {
            appId: data.appId,
            timeStamp: data.timeStamp,
            nonceStr: data.nonceStr,
            package: data.package,
            signType: data.signType,
            paySign: data.paySign
          }),
            response => {
              if (
                response.err_msg.toLowerCase() === "get_brand_wcpay_request:ok"
              ) {
                alert("支付成功");
              } else if (
                response.err_msg.toLowerCase() ===
                "get_brand_wcpay_request:cancel"
              ) {
                alert("支付取消");
              } else if (response.err_msg === "get_brand_wcpay_request:fail") {
                alert(JSON.stringify(response));
              }
            };
        }
      });
    },
    handleCopyClick(text) {
      this.$copyText(text).then(
        () => {
          Toast({
            message: "已复制！",
            duration: 1000
          });
        },
        () => {
          Toast({
            message: "复制失败！",
            duration: 1000
          });
        }
      );
    }
  }
};
</script>

<style lang="scss">
.btn-copy {
  -webkit-transform: translateY(2px);
  -moz-transform: translateY(2px);
  -ms-transform: translateY(2px);
  -o-transform: translateY(2px);
  transform: translateY(2px);
  margin-left: 0.1rem;
  color: #0b92e6;
}
#order-item {
  background-color: #fff;
  color: #000;
  font-size: 0.375rem;
  line-height: 0.65rem;
  display: flex;
  margin-bottom: 0.25rem;
  padding: 0 0.25rem;

  &:active {
    background-color: #e8e8e8;
  }

  .order-icon {
    display: block;
    height: 0.7rem;
    width: 0.7rem;
    margin: 0.25rem;
    background: url(../assets/icon1.png) center/contain no-repeat;
  }

  .container {
    position: relative;
    padding-top: 0.25rem;
    flex: 1;
    padding-bottom: 0.25rem;

    .item-header {
      display: flex;
      align-items: center;

      .item-number {
        flex: 1;
      }
    }

    .order-company {
      display: flex;
      font-size: 0.35rem;

      .order-time {
        flex: 1;
        color: #999;
      }
    }

    .order-detail {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      div {
        width: 20%;
        p {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }

      .area {
        color: #999;
        font-size: 0.35rem;
      }

      .order-status {
        flex: 1;
        display: flex;
        align-items: center;
        text-align: center;

        p {
          overflow: visible;
          margin: auto;
          color: #fff;
          background: rgb(255, 84, 84);
          width: 50%;
          height: 1rem;
          line-height: 1rem;
          border-radius: 0.5rem;
          position: relative;

          &::before {
            content: "";
            display: block;
            position: absolute;
            width: 44%;
            height: 6px;
            left: -0.8rem;
            top: 50%;
            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            -o-transform: translateY(-50%);
            transform: translateY(-50%);
            background: url(../assets/icon_left.png) center/100% no-repeat;
          }

          &::after {
            content: "";
            display: block;
            position: absolute;
            width: 44%;
            height: 6px;
            right: -0.8rem;
            top: 50%;
            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            -o-transform: translateY(-50%);
            transform: translateY(-50%);
            background: url(../assets/icon_right.png) center/100% no-repeat;
          }
        }
      }
    }

    .pay-button {
      float: right;
      background-color: rgb(243, 146, 41);

      &[disabled="disabled"] {
        color: #000;
        background-color: rgb(230, 230, 230);
      }
    }
  }
}
</style>
